import docsReducer from './docsReducer'
import syncUiReducer from './syncUi/syncUiReducer'

export const syncUi = syncUiReducer

export default docsReducer
